module.exports = __webpack_public_path__ + "media/loans/green-check-pros-58bc5829.svg";